/* eslint-disable react-hooks/exhaustive-deps */
import AntSelect, { AntOption } from "containers/backend/common/component/AntSelect";
import { capitalizeFirstLetter, formatMoney } from "helpers/functions";
import React, { memo } from "react";
import { cloneDeep } from 'lodash';
import { Button, Icon } from "antd";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import * as objectTypeActions from './../../../../../../../../actions/objectTypeAction';
import { OBJECT_RATE_CODE_TYPE } from "constants/Define";
const ComboRateCode = ({ t, rateCodes, allObjectType, setObjectForCombo, isCombo, allObjectTypeForVinWonderWithRateCodeType }) => {
    const onChangeObjectType = (objectId, index) => {
        const rateCodeList = cloneDeep(rateCodes);
        const object = allObjectTypeForVinWonderWithRateCodeType.find(x=>x.id === objectId);
        rateCodeList[index]["objectTypeId"] = objectId;
        rateCodeList[index]["objectTypeCode"] = object?.code;
        rateCodeList[index]["objectTypeName"] = object?.name;
        setObjectForCombo(rateCodeList);
    }

    const onRemoveObjectType = (index) => {
        const rateCodeList = cloneDeep(rateCodes);
        rateCodeList.splice(index, 1)
        setObjectForCombo(rateCodeList);
    }

    const newAllObjectTypeForVinWonderWithRateCodeType = cloneDeep(allObjectTypeForVinWonderWithRateCodeType).filter((record) => record?.rateCodeType ==  OBJECT_RATE_CODE_TYPE.Single.id)

    return (
        <div>
            {
                rateCodes.map((r, index) => (
                    <div key={index} className="d-flex align-items-center justify-content-between mb-1">
                        <div>{`${r.code} | ${r.name} | ${formatMoney(r.sellCost)}`}</div>
                        <div className="d-inline-flex align-items-center ml-1">
                            <AntSelect key={index} className="select-destination"
                                showArrow showSearch
                                placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.tourTicket.objectType")).toLowerCase())}
                                   value={ r.objectTypeId }
                                onChange={(id) => onChangeObjectType(id, index)}
                                style={{ width: '150px' }}
                            >
                                {
                                    (newAllObjectTypeForVinWonderWithRateCodeType || []).map(d => (
                                        <AntOption key={d.id} value={d.id}>{d.name} - {d.code}</AntOption>
                                    ))
                                }
                            </AntSelect>

                            <Button className="ml-1" size="large" onClick={() => onRemoveObjectType(index)}>
                                <Icon type="delete" />
                            </Button>
                        </div>
                    </div>
                ))
            }

        </div>
    )
}

export default memo(ComboRateCode);